import {
  AfterViewInit,
  Component, inject,
  input,
  Input,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { STComponent } from '@delon/abc/st';
import { ACLService } from '@delon/acl';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { finalize } from 'rxjs/operators';
import { DocListBaseService } from 'src/app/shared-feature/services/_base/doc-list-base.service';

import { ActionItem } from '../action-item';
import { EmailStatusService } from '@shared-feature/components/email-status-modal/email-status.service';

//import { IntroService } from 'src/app/shared/services/intro.service';

@Component({
  selector: 'app-doc-list-actions',
  templateUrl: './doc-list-actions.component.html',
  styleUrls: ['./doc-list-actions.component.less'],
  standalone: false
})
export class DocListActionsComponent implements OnInit, AfterViewInit {
  @ViewChild('form') form!: NgForm;
  @Input() extraActions: TemplateRef<any> | null = null;

  @Input() moreActions: ActionItem[] = [];

  @Input() aclKey: string | undefined;
  @Input() showEInvStatus: boolean = false;
  @Input() isSelfBilled: boolean = false;
  @Input() showStatus: boolean = false;
  @Input() showAPStatus: boolean = false;
  @Input() showMatchToAROR: boolean = false;
  @Input() showMatchToAPPV: boolean = false;
  @Input() showFilterBtn: boolean = true;
  // remove if all have apply consolidate
  @Input() isConsoExist: boolean = false;
  @Input() showSearchInput: boolean = true;
  @Input() useDevExpress: boolean = false;

  @Input() showBulkApprove: boolean = false;
  private _st: STComponent | undefined;
  get st(): STComponent | undefined {
    return this._st;
  }

  @Input() set st(component: STComponent | undefined) {
    this._st = component;
    this.srv.st = component;
  }

  @Input() dxGrid: DxDataGridComponent | undefined;


  filterVisible = false;
  drawerVisible = false;
  filter: any = { period: [], status: [], eInvStatus: [], eInvControl: [] };
  _docStatus: string[] = [];

  get canCreate() {
    if (this.aclKey) {
      return this.acl.can({ ability: [`${this.aclKey}.create`] });
    }

    return true;
  }

  get canDelete() {
    if (this.aclKey) {
      return this.acl.can({ ability: [`${this.aclKey}.delete`] });
    }

    return true;
  }

  emailStatusService = inject(EmailStatusService);

  constructor(
    public srv: DocListBaseService,
    private acl: ACLService
  ) {
    //private intro: IntroService
  }

  transStatusOptions = [
    { value: 'All', label: 'All' },
    { value: 'Fully Paid', label: 'Fully Paid' },
    { value: 'Partially Paid', label: 'Partially Paid' },
    { value: 'Unpaid', label: 'Unpaid' },
    { value: 'Cancelled', label: 'Cancelled' }
  ];

  apTransStatusOptions = [
    { value: 'All', label: 'All' },
    { value: 'Fully Matched', label: 'Fully Matched' },
    { value: 'Partially Matched', label: 'Partially Matched' },
    { value: 'Unapplied', label: 'Unapplied' },
    { value: 'Cancelled', label: 'Cancelled' }
  ];

  statusOption = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Submitted', label: 'Submitted' },
    { value: 'Valid', label: 'Valid' },
    { value: 'Invalid', label: 'Invalid' },
    { value: 'Cancelled', label: 'Cancelled' }
  ];

  validationControls = [
    { value: 'Draft', label: 'Draft/Consolidated', selfBilled: true },
    { value: 'Full', label: 'Full Validation', selfBilled: true },
    { value: 'Portal', label: 'E-Invoice Portal', selfBilled: false },
    { value: 'Exempted', label: 'Exempted', selfBilled: true }
  ];

  onReload() {
    if (this.useDevExpress) {
      this.dxGrid?.instance.refresh();
      return;
    }
    if (this.st) this.st.reset();
  }

  ngAfterViewInit(): void {
    this.srv.st = this.st;
  }

  ngOnInit(): void {
    this.srv.aclKey = this.aclKey;
    this.srv.period = [];
    this.srv.status = [];
    this.srv.searchValue = '';
    this.srv.deleting = false;
    this.srv.selectedRows = [];
    this.srv.isConsoExist = this.isConsoExist;
  }

  handleDelete() {
    this.srv.modalService.confirm({
      nzTitle: 'Confirmation',
      nzContent: 'Are you sure you want to delete the selected transaction(s)?',
      nzClassName: 'modal-btn',
      nzOnOk: () => {
        this.delete();
      },
      nzOkDanger: true,
      nzOkText: 'Confirm Delete'
    });
  }

  handleTransferToAROR() {
    this.srv.onAction('matchToAROR', this.srv.selectedRows).then(() => {});
  }

  handleTransferToAPPV() {
    this.srv.onAction('matchToAPPV', this.srv.selectedRows).then(() => {});
  }

  handleBulkApprove() {
    // need to set grids on loading state when its start and end loading when its end
    if (this.useDevExpress)
      this.dxGrid?.instance?.beginCustomLoading('Loading...');
    // Use service loading property for custom operations
    this.srv.loading = true;
    this.srv
      .onAction('bulkApprove', this.srv.selectedRows)
      .then(() => {
        if (this.useDevExpress) this.dxGrid?.instance.refresh();
        if (this.st) this.st.reload();
      })
      .finally(() => {
        if (this.useDevExpress) this.dxGrid?.instance?.endCustomLoading();
        // Reset service loading property
        this.srv.loading = false;
      });
  }

  delete(): void {
    const ids = this.srv.selectedRows.map(x => x.id);
    this.srv.onAction('delete', this.srv.selectedRows).then(() => {
      this.srv.deleting = true;
      this.srv
        .batchDelete(ids)
        .pipe(
          finalize(() => {
            this.srv.deleting = false;
          })
        )
        .subscribe(() => {
          this.srv.selectedRows.forEach(item => {
            this.srv.removeRow(item);
          });
          this.srv.selectedRows = [];
          if (this.st) this.st.reload();
          if (this.useDevExpress) {
            this.dxGrid?.instance.refresh();
          }
        });
    });
  }

  showFilter() {
    this.filter.period = this.srv.period;
    this.filter.status = this.srv.status;
    this.filter.eInvStatus = this.srv.eInvStatus;
    this.filter.eInvControl = this.srv.eInvControl;
  }

  closeFilter() {
    this.filterVisible = false;
    this.filter.period = this.srv.period;
    this.filter.status = this.srv.status;
    this._docStatus = this.srv.status;
    this.filter.eInvStatus = this.srv.eInvStatus;
    this.filter.eInvControl = this.srv.eInvControl;
  }

  submitFilter() {
    this.srv.period = this.filter.period;
    this.srv.status = this.filter.status;
    this.srv.eInvStatus = this.filter.eInvStatus;
    this.srv.eInvControl = this.filter.eInvControl;
    this.filterVisible = false;
    if (this.st) this.st.reset();
  }

  resetFilter() {
    this.filter.period = [];
    this.filter.status = [];
    this._docStatus = [];
    this.filter.eInvStatus = [];
    this.filter.eInvControl = [];
  }

  search(keyword: string) {
    if (this.srv.searchValue === keyword) {
      return;
    }
    this.srv.searchValue = keyword;
    if (this.st) this.st.reset();
  }

  handleItemClick(item: ActionItem) {
    if (item.iif && !item.iif()) return;
    item.click();
  }

  statusChange(selectedValues: string[], type: string): void {
    // Select the appropriate options list based on type
    const optionsList =
      type === 'DN' ? this.transStatusOptions : this.apTransStatusOptions;
    const optionsLength = optionsList.length;

    // Find the latest selected or deselected value
    const added = this._docStatus.length
      ? selectedValues.find(value => !this._docStatus.includes(value))
      : selectedValues[0];
    const removed = this._docStatus.find(
      value => !selectedValues.includes(value)
    );

    if (removed === 'All') {
      // "All" was deselected - clear all selections
      this.filter.status = [];
    } else if (
      added === 'All' ||
      (selectedValues.length === optionsLength - 1 &&
        !selectedValues.includes('All'))
    ) {
      // "All" or all of the options(other than 'All') was selected - select all options
      this.filter.status = optionsList.map(option => option.value);
    } else if (selectedValues.length < optionsLength) {
      // Some of the options selected but not all - deselect "All" if it’s included
      this.filter.status = selectedValues.filter(value => value !== 'All');
    } else {
      this.filter.status = selectedValues;
    }

    // Update the previousStatus to the latest state
    this._docStatus = this.filter.status;
  }

  // onTransactionViewChange() {
  //   setTimeout(() => {
  //     const currentView = this.srv.transactionView;
  //     if (this.st && currentView !== 2) this.st.resetColumns();
  //   }, 100);
  // }
}
